import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { DashboardService } from "./dashboard.service";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { FormBuilder, Validators } from "@angular/forms";
import { ExcelService } from "./excel.service";
import { CommonService } from "src/app/common/common.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"]
})

export class DashboardComponent implements OnInit {
  constructor(
    private dashboardService: DashboardService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private excelService: ExcelService,
    private CommonService: CommonService
  ) { }
  userDetail: any;
  courseData = [];
  userData = [];
  CoursePlanData = [];
  monthlyTransaction = [];
  monthlyuserList = [];
  reportAnswereData: {

  }
  totalReports: number = 0
  uniqueAnswersReported: number = 0;
  unreadCount: number = 0;
  showMonthlyUser: boolean = true;
  showMontlyQuestion: boolean = false;
  showUserTrendDaily: boolean = false;
  UserTrendDaily: any;
  QuestionTrendDaily: any;

  // CourseTrendDaily = [
  //   { "name": "Daily Course", "series": [{ "value": 2, "name": "9-12-2030" }, { "value": 2, "name": "9-13-2019" }, { "value": 6, "name": "9-14-2019" }, { "value": 5, "name": "9-15-2019" }, { "value": 9, "name": "9-16-2019" }, { "value": 12, "name": "9-17-2019" }, { "value": 4, "name": "9-18-2019" }, { "value": 9, "name": "9-19-2019" }, { "value": 3, "name": "9-20-2019" }, { "value": 5, "name": "9-21-2019" }, { "value": 8, "name": "9-22-2019" }, { "value": 9, "name": "9-23-2019" }, { "value": 1, "name": "9-24-2019" }, { "value": 4, "name": "9-25-2019" }, { "value": 3, "name": "9-26-2019" }, { "value": 4, "name": "9-27-2019" }, { "value": 2, "name": "9-28-2019" }, { "value": 3, "name": "9-29-2019" }, { "value": 5, "name": "9-30-2019" }] }]
  //   ;

  CourseData = [{ value: 10, name: "DIABETES" }, { value: 8, name: "GENERAL HEALTH IMPROVEMENT" }, { value: 12, name: "HYPERTENSION" }, { value: 13, name: "NEW COURSE" }]
  PlanData = [{ value: 15, name: "Prepare" }, { value: 20, name: "Action" }]

  //Chart
  showLegend = true;
  colorScheme = {
    domain: ["#5AA454", "#A10A28", "#C7B42C", "#AAAAAA"]
  };
  dateRange: any;
  clubList = [];
  p: number = 1;
  searchText: any;
  dashboardCount: any;

  totalUsersCount: number;
  totalAnswere: number;
  totalQuestion: number;
  totalCourse: number;
  clubUsers: number;
  totalBooking: number;
  totalEvent: number;



  ngOnInit() {
    this.userDetail = this.CommonService.getUser();
    this.getDashboardCount();
    this.getUserData();
    this.getCourseData();
    // this.getCoursePlanData();
    this.getUserDailyTrend();
    // this.getMonthlyQuestionTrend();
    // this.getreporedAnswereData()


  }


  getDashboardCount() {
    this.dashboardService.getDashboardCount().subscribe(res => {
      if ((res["message"] = "Success")) {
        this.totalUsersCount = res["data"]["totalUsers"];
        this.totalCourse = res["data"]["totalCourses"];
        this.totalQuestion = res["data"]["totalQuestions"];
        this.totalAnswere = res['data']['totalAnswers'];
      }
    });
  }

  getUserData() {
    this.dashboardService.getUserData().subscribe(res => {
      if ((res["message"] = "Success")) {
        this.userData = res.data;
      }
    });
  }
  getCourseData() {
    this.dashboardService.getCourseData().subscribe(res => {
      if ((res["message"] = "Success")) {
        this.courseData = res.data;
      }
    });
  }
  getCoursePlanData() {
    this.dashboardService.getCoursePlanData().subscribe(res => {
      if ((res["message"] = "Success")) {
        this.CoursePlanData = res.data;
      }
    });
  }

  getreporedAnswereData() {
    this.dashboardService.getReportedAnswereData().subscribe(res => {
      if ((res["message"] = "Success")) {
        this.reportAnswereData = res.data;
        this.totalReports = res.data.totalReports;
        this.uniqueAnswersReported = res.data.uniqueAnswersReported;
        this.unreadCount = res.data.unreadCount;
      }
    });
  }


  getUserDailyTrend() {
    this.dashboardService.getMonthlyUserDaily().subscribe(res => {
      if (!res["msg"]) {
        this.UserTrendDaily = res;
        // Reverse the series to display data left to right
        if (this.UserTrendDaily && this.UserTrendDaily.length > 0 && this.UserTrendDaily[0].series) {
          this.UserTrendDaily[0].series = this.UserTrendDaily[0].series.slice().reverse();
        }
        this.showUserTrendDaily = true;
      }
    });
  }

  getMonthlyQuestionTrend() {
    this.dashboardService.getMonthlyQuestion().subscribe(res => {
      if (!res["msg"]) {
        this.QuestionTrendDaily = res;
        this.showMontlyQuestion = true;
      }
    });
  }

  navigateuser() {
    console.log('insde navigate user');
  }


  onSelect(event) { }

}
